<template>
  <div class="one-time-pass-complete-pane">
    <h3 class="one-time-pass-complete-pane__title">
      {{ $tc('MypagePage.MypageOneTimePass.completePage.title') }}
    </h3>
    <p
      class="one-time-pass-complete-pane__message"
      v-html="$tc('MypagePage.MypageOneTimePass.completePage.message')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * マイページ: ワンタイムパス: 登録完了ペイン
 */
export default defineComponent({
  name: 'OneTimePassCompletePane',
})
</script>

<style lang="scss" scoped>
.one-time-pass-complete-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  margin: 0 auto;
  padding: 80px 10px;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
  color: $gray75;
  background: $gray1;
  font-feature-settings: 'palt' on;
  letter-spacing: 0.04em;
  font-family: $fontSignup;

  &__title {
    @include fontSetTextMedium(17);

    line-height: 1.41;
    font-weight: 500;
  }

  &__message {
    margin-top: 24px;
    @include fontSetTextMedium(13);

    color: $gray75;
  }
}
</style>
